<template>
  <div class="order-bill-warp">
    <div >
      <h1>Receipt – Your Voozaa Rental</h1>

      <p class="spacer">Thank you for recharging with Voozaa!</p>
      <p class="spacer">Send invoice to email:</p>

      <div class="success-email">
        <input
          type="email"
          :placeholder="resultI18n.email"
          v-model.trim="email"
        />
        <span @click="onSend">{{ resultI18n.send }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import dayjs from 'dayjs'
import { SEND_INVOICE } from '@/apis/user'
export default {
  components: {
  },
  computed: {
    resultI18n() {
      return this.$t('result')
    },
    i18nMsg() {
      return this.$t('msg')
    }
  },
  watch: {
  },
  data () {
    return {
      info: {},
      timeText: '00:00:00',
      jieSuan: 0
    }
  },
  methods: {
    onSend() {
      if (!this.email) {
        return
      }
      this.$loading(true)
      this.$post(
        SEND_INVOICE,
        {
          orderId: this.$route.query.outTradeNo,
          email: this.email
        },
        (resp) => {
          this.$loading(false)
          setTimeout(() => {
            this.$toast(this.i18nMsg.sendsuccess)
          }, 500)
        },
        (error) => {
          this.$loading(false)
          setTimeout(() => {
            this.$toast(error)
          }, 500)
          console.log(error)
        },
        {
          headers: {
            "content-type": "application/json;charset=UTF-8"
          }
        }
      )
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.order-bill-warp {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.5;
  text-align: justify;
  font-size: 12pt;
  margin: 16px;
}

p {
    margin: 6px 0;
}

h1 {
    text-align: left;
    font-size: 16pt;
}

table {
    font-size: inherit;
    width: 80%;
    margin: auto;
}

.addressfield {
    font-style: normal;
}

.page-break {
    page-break-before: always;
}

.single_merchant {
    border: none;
    width: 100%;
}

.addressfield {
    padding-top: 30px;
    padding-bottom: 2cm;
}

.spacer {
    margin: 24px 0;
}

tr.space td {
    padding-bottom: 12px;
}

.bold {
    font-weight: bold;
}

.italic {
    font-style: italic;
}

.description {
    text-align: left;
}

.value {
    font-variant-numeric: tabular-nums;
    text-align: right;
    white-space: nowrap;
}
/* header style */
header {
    font-family: Afacad, Arial, Helvetica, sans-serif;
    margin: 0px;
    padding: 0px;
}

.logo-text {
    font-size: 24px; /*24px*/
    font-weight: bold;
}

.logo-subtext {
    font-size: 14px; /*14px*/
    font-weight: 600;
    text-align: left;
}

.logo, .address {
    display: table-cell;
    vertical-align: middle;
}
.address {
    width: 40%;
    max-width: 50%;
}
.header {
    background: linear-gradient(45deg, #EFFF20, #ABFFDC);
    color: #292929;
    border-radius: 10px;
    padding: 5px 0px 5px 10px;
    display: table;
    table-layout: fixed;
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
}

.logo {
    text-align: left;
    padding-right: 5px;
    width: auto;
}

.logo img {
    width: 200px;
    height: auto;
    vertical-align: middle;
}
.success-email {
  display: flex;
  margin: 40px 40px 20px 30px;
  align-items: center;
  input {
    flex: 1;
    padding: 20px 15px;
    border: solid 1px #e2e2e2;
    border-radius: 20px;
    font-size: 32px;
    outline: none;
  }
  span {
    width: max-content;
    margin-left: 20px;
    color: #00ab46;
    font-weight: bold;
  }
}
</style>
